import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { create } from 'zustand';

interface TopbarSlotState {
  node: HTMLElement | null;
  setNode: (node: HTMLElement | null) => void;
}

/** The place in the topbar, next to the active operation, where the open page puts its own
 *  actions (header proposal 11). Only one page is open, so there is one primary at a time. */
export const useTopbarSlot = create<TopbarSlotState>((set) => ({
  node: null,
  setNode: (node) => set({ node }),
}));

/** Renders its children in the topbar slot; nothing until the topbar is mounted. */
export function TopbarActions({ children }: { children: ReactNode }) {
  const node = useTopbarSlot((s) => s.node);
  return node === null ? null : createPortal(children, node);
}
